import React, {useEffect} from 'react';
import {getMediaUrl, getVideoURL} from '../../../api/hooks';

const SingleMedia = ({media, mediaType, setMediaType, headerType, setVideoUrl}) => {
    const imageType = headerType === 'filter' ? 'detail' : 'teaser';
    const mediaUrl = (media[0] && headerType) ? getMediaUrl(media[0].id, media[0].context, 'large', imageType) : media;

    useEffect(() => {
        if (setMediaType) {
            setMediaType(headerType ? media[0].type : 'image');
            if (mediaType === 'video') {
                const url = getVideoURL(media[0]);
                setVideoUrl(url);
            }
        }
    }, [headerType, media, mediaType, setMediaType, setVideoUrl]);

    return (
        <>
            <div className="bg_image_holder" style={{backgroundImage: `url("${mediaUrl}")`, opacity: 1}} />
            <p className="single-media-copyright" title={media[0] && media[0].copyright && ('© ' + media[0].copyright)}>
                {media[0] && media[0].copyright && ('© ' + media[0].copyright)}
            </p>
        </>

    );
};

export default SingleMedia;
